import {gettext} from 'topmeteo/utils/i18n';

const Label = gettext('Inclusive');

const Option = ({label, inclusive, price, formatCurrency}) => (
    <tr>
        <td>{label}</td>
        <td className="price">{inclusive ? Label : formatCurrency(price)}</td>
    </tr>
);

export default Option;
